import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getUniqueCarrierCount = {
  name: "getUniqueCarrierCount" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
